import { render, staticRenderFns } from "./AugmentationsGrid.vue?vue&type=template&id=5d80b55e&scoped=true&"
import script from "./AugmentationsGrid.vue?vue&type=script&lang=js&"
export * from "./AugmentationsGrid.vue?vue&type=script&lang=js&"
import style0 from "./AugmentationsGrid.vue?vue&type=style&index=0&id=5d80b55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d80b55e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
